(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-footer"] && !Shopify.designMode) return;
  try {
    
  const foot = document.querySelector("[data-cw-foot]");
  if (foot) {
    const core=foot.querySelector('#cw-footer-details');
    if(core && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      const coreObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){[...core.children].forEach((el,i)=>el.animate([{opacity:.25,translate:'0 22px'},{opacity:1,translate:'0 0'}],{duration:750,delay:i*100,easing:'cubic-bezier(.2,.8,.2,1)'}));coreObserver.disconnect();}},{threshold:.08});coreObserver.observe(core);
    }
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              foot.classList.add("is-seen");
              io.disconnect();
            }
          });
        },
        { threshold: 0.05 }
      );
      io.observe(foot);
    } else {
      foot.classList.add("is-seen");
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-hero"] && !Shopify.designMode) return;
  try {
    
  function cwHeroMotion(root) {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.cw-hero video').forEach(function (video) {
      video.autoplay = false;
      video.pause();
    });
  }
  cwHeroMotion(document);
  document.addEventListener('shopify:section:load', function (event) { cwHeroMotion(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-masthead"] && !Shopify.designMode) return;
  try {
    
  const mast = document.querySelector("[data-cw-mast]");
  if (mast) {
    const openBtns = mast.querySelectorAll("[data-cw-mega-open]");
    const mega = mast.querySelector("[data-cw-mega]");
    const tabs = mast.querySelectorAll("[data-tab]");
    const panels = mast.querySelectorAll("[data-panel]");

    let lastTrigger = null;
    const setOpen = (open) => {
      mega.hidden = !open;
      openBtns.forEach((btn) => btn.setAttribute("aria-expanded", open ? "true" : "false"));
    };

    openBtns.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.stopPropagation();
        lastTrigger = btn;
        setOpen(mega.hidden);
      });
    });
    document.addEventListener("click", (event) => {
      if (!mast.contains(event.target)) setOpen(false);
    });

    tabs.forEach((tab, index) => {
      tab.id = 'cw-menu-tab-' + tab.dataset.tab;
      tab.setAttribute('aria-controls', 'cw-menu-panel-' + tab.dataset.tab);
      tab.tabIndex = index === 0 ? 0 : -1;
      const panel = Array.from(panels).find(p => p.dataset.panel === tab.dataset.tab);
      if(panel){panel.id='cw-menu-panel-'+tab.dataset.tab;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);}
      tab.addEventListener('keydown', event => {
        const keys=['ArrowLeft','ArrowRight','Home','End'];if(!keys.includes(event.key))return;
        event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
        tabs[next].click();tabs[next].focus();
      });
      tab.addEventListener("click", () => {
        tabs.forEach((el) => {
          el.classList.toggle("is-on", el === tab);
          el.setAttribute("aria-selected", el === tab ? "true" : "false");
          el.tabIndex = el === tab ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.getAttribute("data-panel") !== tab.getAttribute("data-tab");
        });
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !mega.hidden) { setOpen(false); if (lastTrigger) lastTrigger.focus(); }
    });

    // Compact bar after the first scroll, and close the mega menu on the way.
    let stuck = false;
    const onScroll = () => {
      const next = window.scrollY > 24;
      if (next === stuck) return;
      stuck = next;
      mast.classList.toggle("is-stuck", stuck);
      if (stuck && mega && !mega.hidden) setOpen(false);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
